import { Chip } from "@mui/material";

// Operators in words, for the Condition column
export const OP_WORDS = { "<": "Less than", "<=": "At most", ">": "More than", ">=": "At least", "==": "Equals", "!=": "Not equal to" };

const OUTCOME_CHIP_COLORS = { green: "success", orange: "warning", red: "error" };

// Green / Orange / Red, with the theme's fibePill chips
export function OutcomeChip({ color }) {
  const label = color ? color.charAt(0).toUpperCase() + color.slice(1) : "—";
  return <Chip size="small" variant="fibePill" color={OUTCOME_CHIP_COLORS[color] || "default"} label={label} />;
}
